module.exports = __webpack_public_path__ + "img/candle-burning-2.c78a875b.png";